import { TxActions, TxActionTypes } from "actions";
import { TxInterface } from "interfaces/tx.interface";

interface TxState {
  tx: TxInterface | null;
  loading: boolean;
  error: string | null;
}

const initialState: TxState = {
  tx: null,
  loading: false,
  error: null,
};

const txReducer = (state = initialState, action: TxActions): TxState => {
  switch (action.type) {
    case TxActionTypes.FETCH_TX_REQUEST:
      return { ...state, loading: true, error: null };
    case TxActionTypes.FETCH_TX_SUCCESS:
      return { ...state, loading: false, tx: action.payload };
    case TxActionTypes.FETCH_TX_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default txReducer;
